import classNames from 'classnames';
import { sendMenuClickEvent } from 'helpers/analyticsEvents';
import React, { useCallback } from 'react';

import { Icon } from '@sravni/react-design-system';
import {
  Analytics,
  Bank,
  BeautyAndHealth,
  BlankStamp,
  BookOpen,
  Briefcase,
  Bug,
  BusinessAccounting,
  Calculations,
  Car,
  CardPlus,
  CardTerminal,
  CardTimer,
  CardTransfer,
  ChartDown,
  Creation,
  CursorSelected,
  Deposit,
  Design,
  DollarExchange,
  Exchange,
  FileCrossOut,
  Globe,
  House,
  HouseSafety,
  IdentityCard,
  InsuranceHouse,
  Lungs,
  Management,
  Marketing,
  MyCredits,
  Needlework,
  Orders,
  Plane,
  PopularProfessions,
  PrizeCup,
  ProductsSearch,
  Programming,
  QnA,
  Scoring,
  Shield,
  ShieldLock,
  SoftSkills,
  Star,
  Stethoscope,
  Wallet,
  WalletBag,
} from '@sravni/react-icons';

import * as Icons from '../Icons/Products';

import styles from './service-menu.module.scss';

const itemsList: Record<string, { icon: any; adEvent: { [key: string]: string }; isSpecialIcon?: boolean }> = {
  scoring: {
    icon: <Scoring />,
    adEvent: {
      category: 'Кредитный рейтинг',
    },
  },
  mortgage: {
    icon: <House />,
    adEvent: {
      category: 'Ипотека',
    },
  },
  mortgageInsurance: {
    icon: <HouseSafety />,
    adEvent: {
      category: 'Страхование ипотеки',
    },
  },
  savings: {
    icon: <Deposit />,
    adEvent: {
      category: 'Вклады',
    },
  },
  'credit-cards': {
    icon: <Icons.CreditCard />,
    adEvent: {
      category: 'Кредитные карты',
    },
  },
  'debit-cards': {
    icon: <CardPlus />,
    adEvent: {
      category: 'Дебетовые карты',
    },
  },
  microloan: {
    icon: <WalletBag />,
    adEvent: {
      category: 'Микрокредиты',
    },
  },
  osago: {
    icon: <Car />,
    adEvent: {
      category: 'ОСАГО',
    },
  },
  kasko: {
    icon: <Car />,
    adEvent: {
      category: 'КАСКО',
    },
  },
  real: {
    icon: <ShieldLock />,
    adEvent: {
      category: 'Страхование недвижимости',
    },
  },
  insurance: {
    icon: <Plane />,
    adEvent: {
      category: 'ВЗР',
    },
  },
  // 'covid': {
  //   icon: Icons.Covid,
  //   adEvent: {
  //     category: '',
  //   },
  // },
  sport: {
    icon: <PrizeCup />,
    adEvent: {
      category: 'НС',
    },
  },
  refinansirovanie: {
    icon: <Exchange />,
    adEvent: {
      category: 'Рефинансирование кредитов',
    },
  },
  potrebCredits: {
    icon: <Orders />,
    adEvent: {
      category: 'Потребительские кредиты',
    },
  },
  creditCards: {
    icon: <CardTimer />,
    adEvent: {
      category: 'Кредитные карты',
    },
  },
  brokerageService: {
    icon: <Briefcase />,
    adEvent: {
      category: 'Брокерское обслуживание',
    },
  },
  autocred: {
    icon: <Car />,
    adEvent: {
      category: 'Автокредиты',
    },
  },
  specialProjects: {
    icon: <Star />,
    adEvent: {
      category: 'Куда вложить деньги',
    },
  },
  bankrotstvo: {
    icon: <ChartDown />,
    adEvent: {
      category: 'Банкротство',
    },
  },

  credits: {
    icon: <Wallet />,
    adEvent: {
      category: 'Подбор кредита',
    },
  },
  'selection-credit-cards': {
    icon: <Icons.Card />,
    adEvent: {
      category: 'Подбор кредитной карты',
    },
  },
  currencies: {
    icon: <DollarExchange />,
    adEvent: {
      category: 'Валюты',
    },
  },
  'transfer-to-card': {
    icon: <CardTransfer />,
    adEvent: {
      category: 'Переводы',
    },
  },
  'banks-rating': {
    icon: <Bank />,
    adEvent: {
      category: 'Рейтинг',
      label: 'Банки',
    },
  },
  'banks-reviews': {
    icon: <Icons.BanksReviews />,
    adEvent: {
      category: 'Отзывы',
      label: 'Банки',
    },
  },
  'insurance-rating': {
    icon: <Shield />,
    adEvent: {
      category: 'Рейтинг',
      label: 'Страховые компании',
    },
  },
  'insurance-reviews': {
    icon: <Icons.InsuranceReviews />,
    adEvent: {
      category: 'Отзывы',
      label: 'Страховые компании',
    },
  },
  'strahovka-ot-klescha': {
    icon: <Bug />,
    adEvent: {
      category: 'Страхование от укуса клеща',
    },
  },
  'strahovka-kriticheskie-bolezni': {
    icon: <Lungs />,
    adEvent: {
      category: 'Страхование от критических болезней',
    },
  },
  dms: {
    icon: <Stethoscope />,
    adEvent: {
      category: 'Добровольное медицинское страхование',
    },
  },
  'strahovanie-domov': {
    icon: <InsuranceHouse />,
    adEvent: {
      category: 'Страхование дома и дачи',
    },
  },
  qna: {
    icon: <QnA />,
    adEvent: {
      category: 'Вопросы и ответы',
    },
  },
  journal: {
    icon: <Calculations />,
    adEvent: {
      category: 'Контент',
    },
  },
  alfacapital: {
    icon: <Icons.Alfacapital />,
    adEvent: {
      category: 'promo-alfa-capital',
    },
  },
  pik: {
    icon: <Icons.Pik />,
    isSpecialIcon: true,
    adEvent: {
      category: 'pik',
    },
  },

  // образование
  kursy: {
    icon: <PopularProfessions />,
    adEvent: {
      category: 'Образование',
    },
  },
  programming: {
    icon: <Programming />,
    adEvent: {
      category: 'Разработка',
    },
  },
  analytics: {
    icon: <Analytics />,
    adEvent: {
      category: 'Аналитика',
    },
  },
  marketing: {
    icon: <Marketing />,
    adEvent: {
      category: 'Маркетинг',
    },
  },
  management: {
    icon: <Briefcase />,
    adEvent: {
      category: 'Управление',
    },
  },
  design: {
    icon: <Design />,
    adEvent: {
      category: 'Дизайн',
    },
  },
  finansy: {
    icon: <Needlework />,
    adEvent: {
      category: 'Финансы',
    },
  },
  samorazvitie: {
    icon: <SoftSkills />,
    adEvent: {
      category: 'Саморазвитие',
    },
  },
  'marketing-kontent': {
    icon: <Creation />,
    adEvent: {
      category: 'Создание контента',
    },
  },
  beauty: {
    icon: <BeautyAndHealth />,
    adEvent: {
      category: 'Красота и здоровье',
    },
  },
  'inostrannye-yazyki': {
    icon: <Globe />,
    adEvent: {
      category: 'Иностранные языки',
    },
  },
  'ege-oge': {
    icon: <BookOpen />,
    adEvent: {
      category: 'Подготовка к ЕГЭ и ОГЭ',
    },
  },
  // бизнесс
  rko: {
    icon: <CardTerminal />,
    adEvent: {
      category: 'РКО',
    },
  },
  businessCredits: {
    icon: <Briefcase />,
    adEvent: {
      category: 'Кредиты для бизнеса',
    },
  },
  bankGuarantees: {
    icon: <MyCredits />,
    adEvent: {
      category: 'Банковские гарантии',
    },
  },
  acquiring: {
    icon: <Icons.Acquiring />,
    adEvent: {
      category: 'Эквайринг',
    },
  },
  depositsForBusiness: {
    icon: <Icons.CoinRub />,
    adEvent: {
      category: 'Вклады для бизнеса',
    },
  },
  businessRegistration: {
    icon: <BlankStamp />,
    adEvent: {
      category: 'Регистрация бизнеса',
    },
  },
  businessAccounting: {
    icon: <BusinessAccounting />,
    adEvent: {
      category: 'Бухгалтерия для бизнеса',
    },
  },
  businessMarketplace: {
    icon: <Management />,
    adEvent: {
      category: 'Бизнес на маркетплейс',
    },
  },
  leasing: {
    icon: <ProductsSearch />,
    adEvent: {
      category: 'Лизинг',
    },
  },
  businessLiquidation: {
    icon: <FileCrossOut />,
    adEvent: {
      category: 'Ликвидация ИП',
    },
  },
  biznesOformlenieSamozanyatogo: {
    icon: <IdentityCard />,
    adEvent: {
      category: 'Сервис регистрации самозанятых',
    },
  },
  biznesVnesenieIzmeneniy: {
    icon: <CursorSelected />,
    adEvent: {
      category: 'Внесение изменений в ИП и ООО',
    },
  },
};

interface IMenuItemProps {
  item: {
    hide?: boolean;
    name: string;
    link: string;
    key: string;
  };
  className?: string;
}

const MenuItem: React.FC<IMenuItemProps> = React.memo(({ item, className }) => {
  const handleClickLink = useCallback(() => {
    sendMenuClickEvent(itemsList[item.key].adEvent);
  }, [item.key]);

  if (item.hide) {
    return null;
  }

  return (
    <a className={classNames(styles['menu-item'], className)} href={item.link} onClick={handleClickLink}>
      <div className={classNames(styles.icon, { [styles['icon--specialIcon']]: itemsList[item.key].isSpecialIcon })}>
        <Icon icon={itemsList[item.key].icon} size={28} />
      </div>
      <div className={styles['menu-item__title']} dangerouslySetInnerHTML={{ __html: item.name }} />
    </a>
  );
});

export default MenuItem;
